// Module
var code = "<div class=\"clone-editor\">\n  <form name=\"componentForm\" novalidate>\n    <p class=\"lead\">{{:: 'clone-editor.title' | translate}}</p>\n  </form>\n</div>\n";
// Exports
module.exports = code;